import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { showBookToTaxDifferenceModalForDelete } from './store/actions';
import ValidationMessagesCellRenderer from '../../shared/gridEdit/validationMessagesCellRenderer.component';
import { GridMode } from '../../shared/gridEdit/useEditableGridLogic';
import { BookToTaxDifferencePropTypes } from '../../shared/propTypes/bookToTaxDifference';

const b2tRowIsEdited = ({ editedRowId, bookToTaxDifference }) => editedRowId === bookToTaxDifference.exceptionId;

const BookToTaxDifferencesAdminColumnRenderer = props => {
  const {
    data: bookToTaxDifference,
    rowIndex,
    showDeleteBookToTaxDifferenceModal,
    editRow,
    context,
  } = props;

  const {
    mode,
    canModify,
    editedRowId,
  } = context;

  const showDeleteModal = useCallback(() => {
    showDeleteBookToTaxDifferenceModal({ entity: bookToTaxDifference, rowIndex });
  }, [showDeleteBookToTaxDifferenceModal, rowIndex, bookToTaxDifference]);

  const onEditClick = useCallback(() => {
    editRow(bookToTaxDifference);
  }, [bookToTaxDifference, editRow]);

  const isEditingMode = mode === GridMode.Add || mode === GridMode.Edit || mode === GridMode.EditAll;
  const isRowEdited = b2tRowIsEdited({ editedRowId, bookToTaxDifference }) || mode === GridMode.EditAll;
  const isDisabled = !canModify || isEditingMode;

  if (isEditingMode && isRowEdited) {
    return <ValidationMessagesCellRenderer {...props} />;
  }

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Book to Tax Difference"
        onClick={onEditClick}
        disabled={isDisabled}
      >
        <PencilIcon size={16} className="cell-icon disabled-visible" />
      </button>
      <button
        className="cell-icon-button"
        title="Remove Book to Tax Difference"
        onClick={showDeleteModal}
        disabled={isDisabled}
      >
        <TrashIcon size={16} className="cell-icon disabled-visible" />
      </button>
    </div>
  );
};

BookToTaxDifferencesAdminColumnRenderer.propTypes = {
  data: BookToTaxDifferencePropTypes,
  showDeleteBookToTaxDifferenceModal: PropTypes.func.isRequired,
  disableRemove: PropTypes.bool,
  disableEdit: PropTypes.bool,
  editRow: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
  context: PropTypes.shape({
    mode: PropTypes.string.isRequired,
    canModify: PropTypes.bool.isRequired,
    editedRowId: PropTypes.number,
  }),
};

export default connect(null, {
  showDeleteBookToTaxDifferenceModal: showBookToTaxDifferenceModalForDelete,
})(BookToTaxDifferencesAdminColumnRenderer);
